import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[noLeadingSpace]',
})
export class NoLeadingSpaceDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onInput(event: KeyboardEvent): void {
    if (event.key === ' ' && this.el.nativeElement.selectionStart === 0) {
      event.preventDefault();
    }
  }
}
